import {
  COMMON_STYLES,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";
import React from "react";
import { useTranslation } from "react-i18next";
import { View, Text, Image, StyleSheet } from "react-native";

interface InfoCardProps {
  title: string;
  description: string;
  icon: any;
}

const InfoCard = ({ title, description, icon }: InfoCardProps) => {
  const { t } = useTranslation();
  return (
    <View style={[COMMON_STYLES.row]}>
      <Image
        source={icon}
        style={{ width: 100, height: 100, marginRight: 12 }}
        resizeMode="contain"
      />
      <View style={[COMMON_STYLES.flex1, COMMON_STYLES.justifyCenter]}>
        <Text
          style={[
            TEXT_STYLES.textNeutral90,
            TYPOGRAPHY.TEXT1,
            VARIANTS_STYLES.EMPHASIZED,
          ]}
        >
          {t(title)}
        </Text>
        <Text style={[TYPOGRAPHY.TEXT2, TEXT_STYLES.textNeutral90]}>
          {t(description)}
        </Text>
      </View>
    </View>
  );
};

export default InfoCard;
